import api from "../axios"
import { ENDPOINT_DEV } from '../configs';

export const getEmailHistoryAPI = async (orgId: string, user: string, search: string) => {
  return await api.get(ENDPOINT_DEV + `booking/email/history?org_id=${orgId}&user=${user}&search=${search}`).then((res) => {
    return res;
  });
};
